<div class="desktop">
    <div *ngIf="!isCustomer && multipleDealerships" class="dealer-title" (click)="changeDealershipClicked()">
        <div *ngIf="!mobileMenu" class="dealer-name" [matTooltip]="multipleDealerships && this.dealerSelection?.name">
            {{ trimDealerName(this.dealerSelection?.name) }}
        </div>
        <div *ngIf="!mobileMenu" class="icon-container">
            <button mat-button class="text-only">Change Dealership</button>
        </div>
    </div>
</div>

<div class="mobile">
    <div *ngIf="!isCustomer && multipleDealerships" class="dealer-title" (click)="changeDealershipClicked()">
        <div *ngIf="!mobileMenu" class="dealer-name mobile" [matTooltip]="multipleDealerships && this.dealerSelection?.name">
            {{ trimDealerName(this.dealerSelection?.name) }}
        </div>
    </div>
</div>

<div *ngIf="!isCustomer && !multipleDealerships" class="dealer-title">
    <div class="dealer-name">{{ this.dealerSelection?.name }}</div>
</div>
